import { Progress } from "@au-schein-de/au-ui-library";
import { useId } from "react";
import { Trans, useTranslation } from "react-i18next";
import { formatCentsAsAmount } from "~/hooks/use-currency-price.hook";
import { useMarket } from "~/hooks/use-market";
import { getFreeDeliveryProgress } from "./free-delivery-progress.logic";

interface CartFreeDeliveryProgressBarProps {
	deliveryCost: number | null | undefined;
	freeFrom: number | null | undefined;
	merchandiseTotalCents: number;
}

export function CartFreeDeliveryProgressBar({
	deliveryCost,
	freeFrom,
	merchandiseTotalCents,
}: CartFreeDeliveryProgressBarProps) {
	const { t } = useTranslation("cart");
	const market = useMarket();
	const labelId = useId();
	const progress = getFreeDeliveryProgress({
		deliveryCost,
		freeFrom,
		merchandiseTotalCents,
	});

	if (!progress.isVisible) {
		return null;
	}

	const amount = formatCentsAsAmount(
		progress.remainingCents,
		market.languageTag,
	);

	return (
		<div
			className="mb-4 flex flex-col gap-1"
			data-testid="cart-free-delivery-progress"
		>
			<p
				id={labelId}
				className="whitespace-pre-line text-body-sm text-blue-700"
			>
				{progress.isUnlocked ? (
					t("freeDelivery.unlocked")
				) : (
					<Trans
						t={t}
						i18nKey="freeDelivery.remaining"
						ns="cart"
						values={{ amount }}
						components={{
							bold: <span className="text-body-sm-emphasis" />,
						}}
					/>
				)}
			</p>
			<Progress
				value={progress.fillPercent}
				className="h-1 bg-blue-100 [&>div]:bg-blue-500 [&>div]:rounded-full"
				aria-labelledby={labelId}
			/>
		</div>
	);
}
